import React, { useEffect, useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { IBonusesListItem } from "./typing/BonusesListItem.interface";
import "./BonusesListItem.css";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/store.hooks";
import { setRegistrationModal } from "../../../store/models/auth/auth.slice";
import { activateGlobalBonus } from "../../../store/models/bonuses/bonuses.thunk";
import { bonusesListItemSelector } from "../Bonuses.selector";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BonusDialog } from "./BonusDialog/bonus.dialog";
import { useMediaQuery } from "react-responsive";
import { Loader } from "../../loader/loader";
import { Image } from "./BonusImage/bonus.image";

const BonusesListItem: React.FC<IBonusesListItem> = ({
  id,
  bg_img,
  sub_img,
  title,
  promo_code,
  customClassName,
  fs,
  pers,
  end_date,
  type,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [infoMessage, setInfoMessage] = useState({ show: false, message: "" });
  const [infoMessageButton, setInfoMessageButton] = useState("");
  const [loading, setLoading] = useState(false);

  const { auth } = useAppSelector(bonusesListItemSelector);

  const dispatch = useAppDispatch();

  const getBonus = async () => {
    if (!auth) {
      dispatch(setRegistrationModal(true));
      return;
    }
    if (promo_code) {
      setLoading(true);

      const message: any = await dispatch(
        activateGlobalBonus({ promocode: promo_code })
      );
      if (message.payload) {
        if (
          message.payload ===
          "Для получения бонуса, аккаунт необходимо верифицировать любым удобным для вас способом"
        ) {
          setInfoMessageButton(t("buttons.getverification"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.verification_required"),
          });
        } else if (message.payload === "Этот бонус был использован ранее") {
          setInfoMessageButton(t("buttons.close"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.used"),
          });
        } else if (
          message.payload ===
          "Данный бонус недоступен для Вашего игрового счета"
        ) {
          setInfoMessageButton(t("buttons.close"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.unvailable"),
          });
        } else if (
          message.payload === "Данный бонус доступен только при регистрации"
        ) {
          setInfoMessageButton(t("buttons.close"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.registration"),
          });
        } else if (
          message.payload ===
          "Бонус был успешно активирован. Пополните игровой счет, чтобы получить его"
        ) {
          setInfoMessageButton(t("buttons.shorttopup"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.activated_deposit"),
          });
        } else if (message.payload === "Бонус был успешно активирован") {
          setInfoMessageButton(t("buttons.play"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.activated"),
          });
        } else if (
          message.payload ===
          "У вас есть другой активный бонус. Завершите его и после сможете принять участие в этом"
        ) {
          setInfoMessageButton(t("buttons.mybonuses"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.other"),
          });
        } else if (message.payload === "Этот бонус не активен") {
          setInfoMessageButton(t("buttons.close"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.disabled"),
          });
        } else if (message.payload === "Bonus not found") {
          setInfoMessageButton(t("buttons.close"));
          setLoading(false);
          setInfoMessage({
            show: true,
            message: t("main.bonuses.dialog.not_found"),
          });
        }
      } else {
        setInfoMessageButton(t("buttons.play"));
        setLoading(false);
        setInfoMessage({
          show: true,
          message: t("main.bonuses.dialog.not_found"),
        });
      }
    } else {
      setInfoMessage({
        show: true,
        message: t("main.bonuses.dialog.not_found"),
      });
      setInfoMessageButton(t("buttons.close"));
    }
  };

  const dialogHandler = () => {
    if (
      infoMessage.message === t("main.bonuses.dialog.verification_required")
    ) {
      navigate("/profile/personal-info/verification");
    } else if (
      infoMessage.message === t("main.bonuses.dialog.activated_deposit")
    ) {
      navigate("/profile/payments");
    } else if (infoMessage.message === t("main.bonuses.dialog.other")) {
      navigate("/profile/bonuses");
    } else if (infoMessage.message === t("main.bonuses.dialog.activated")) {
      navigate("/lobby");
    }
    setInfoMessage({ show: false, message: "" });
  };
  const closeDialog = () => setInfoMessage({ show: false, message: "" });
  useEffect(() => {}, [bg_img, sub_img]);
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  return (
    <React.Fragment>
      <Box
        className={
          customClassName
            ? `${customClassName} bonus-card__container`
            : "bonus-card__container"
        }
      >
        <Box className="bonus-card__image">
          {bg_img ? (
            <Image
              alt={bg_img}
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${bg_img}`}
              classname="bonus-card__bg-image"
            />
          ) : (
            <Box
              className="bonus-card__bg-image"
              sx={{ backgroundColor: "var(--primary-background-color)" }}
            />
          )}
          {sub_img && (
            <Image
              alt={sub_img}
              src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${sub_img}`}
              classname="bonus-card__sub-image"
            />
          )}
        </Box>
        <Box className="bonus-card__content">
          <Box className="bonus-card__content-title">{title}</Box>
          <Box className="bonus-card__content-bonus">
            {t("main.bonuses.item.bonus")}
            <Typography>
              {fs && pers
                ? `${pers.count}% + ${fs.count}FS`
                : fs
                ? `${fs.count}FS`
                : `${pers && pers.count}%`}
            </Typography>
          </Box>
          <Box className="bonus-card__content-game">
            {t("main.bonuses.item.game")}
            <Typography>{fs ? `${fs.game}` : "-"}</Typography>
          </Box>
          <Box className="bonus-card__content-end">
            {t("main.bonuses.item.end")}
            <Typography>
              {+end_date >= Date.now()
                ? formatTimestampToDate(+end_date)
                : t("main.bonuses.item.expired")}
            </Typography>
          </Box>
          <Box className="bonus-card__content-buttons">
            <Link
              to={`/bonuses/${id}`}
              className="bonus-card__content-button-rule"
            >
              {t("main.bonuses.conditions")}
            </Link>
            {+end_date >= Date.now() && type !== "cashback" && (
              <button
                className="bonus-card__content-button-activate"
                onClick={getBonus}
              >
                {t("main.bonuses.get")}
              </button>
            )}
          </Box>
        </Box>
      </Box>
      <BonusDialog
        infoMessage={infoMessage}
        loading={loading}
        infoMessageButton={infoMessageButton}
        closeDialog={closeDialog}
        dialogHandler={dialogHandler}
      />
      <Dialog
        open={loading}
        sx={{
          height: "100vh",
          overflowY: "auto",
          backgroundColor: "transparent",
          ".MuiDialog-container": {
            alignItems: "center",
            backdropFilter: "blur(5px)",
            position: "relative",
          },
          ".MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          sx: {
            margin: isMobile ? "106px 14px 0px 14px" : "0px 14px 0px 14px",
            width: "100%",
            maxWidth: "400px",
            height: isMobile ? "200px" : "300px",
            maxHeight: "100%",
            borderRadius: "var(--primary-border-radius)",
            overflow: "hidden",
            backgroundColor: "var(--secondary-background-color)",
          },
        }}
      >
        <Loader secondary />
      </Dialog>
    </React.Fragment>
  );
};

export default BonusesListItem;

function formatTimestampToDate(timestamp: number) {
  const date = new Date(timestamp);

  // Витягуємо компоненти дати
  const day = String(date.getDate()).padStart(2, "0"); // День (2 цифри)
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Місяць (2 цифри, +1 бо місяці з 0)
  const year = date.getFullYear(); // Рік
  const hours = String(date.getHours()).padStart(2, "0"); // Години (2 цифри)
  const minutes = String(date.getMinutes()).padStart(2, "0"); // Хвилини (2 цифри)

  // Формуємо рядок у форматі "дд.мм.рррр, гг:хх"
  return `${day}.${month}.${year}, ${hours}:${minutes}`;
}
